import React from "react";
import st from "../../style.module.scss";
import { useFieldArray } from "react-hook-form";
import { Form } from "react-bootstrap";
import { FaDotCircle } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

export default ({ nestIndex, k, control, register, errors, setError, clearErrors, getValues }) => {

    const { fields, remove, append } = useFieldArray({
        control,
        name: `noOfYears.${nestIndex}.children.${k}.stockDistribution`,
    });

    return (
        <div>
            <div className="row mt-3">
                <div className="col-4" style={{ paddingLeft: "104px" }}><Form.Label>key</Form.Label></div>
                <div className="col-4" style={{ paddingLeft: "35px" }}><Form.Label>value</Form.Label></div>
                <div className="col-4" ><Form.Label>Action</Form.Label></div>
            </div>
            {fields.map((item, l) => {
                return (
                    <div className="col ps-3" key={item.id} style={{ marginLeft: 20 }}>
                        <Form.Group
                            className={`${st.formField} ${st.new_formFields} d-flex gap-3`}
                        >
                            <span className="btn">
                                <FaDotCircle />
                            </span>
                            <div>
                                <Form.Control
                                    type="text"
                                    placeholder="key"
                                    {...register(`noOfYears.${nestIndex}.children.${k}.stockDistribution.${l}.key`, {
                                        required: "Key is required",
                                    })}
                                    onChange={(event) => {
                                        const flage = getValues(`noOfYears.${nestIndex}.children.${k}.stockDistribution`)?.some(i => i?.key === event?.target.value)
                                        if(!event?.target?.value?.length){
                                            setError(`noOfYears.${nestIndex}.children.${k}.stockDistribution.${l}.key`, { type: 'custom', message: "Key is required" });
                                        }else if (flage) {
                                            setError(`noOfYears.${nestIndex}.children.${k}.stockDistribution.${l}.key`, { type: 'custom', message: 'Duplicate key not allowed' });
                                        } else {
                                            clearErrors(`noOfYears.${nestIndex}.children.${k}.stockDistribution.${l}.key`);
                                        }
                                    }}
                                    isInvalid={!!errors.noOfYears?.[nestIndex]?.children?.[k]?.stockDistribution?.[l]?.key}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.noOfYears?.[nestIndex]?.children?.[k]?.stockDistribution?.[l]?.key?.message}
                                </Form.Control.Feedback>
                            </div>

                            <div>
                                <Form.Control
                                    type="number"
                                    placeholder="value"
                                    {...register(`noOfYears.${nestIndex}.children.${k}.stockDistribution.${l}.value`, {
                                        required: "value is required",
                                    })}
                                    isInvalid={!!errors.noOfYears?.[nestIndex]?.children?.[k]?.stockDistribution?.[l]?.value}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.noOfYears?.[nestIndex]?.children?.[k]?.stockDistribution?.[l]?.value?.message}
                                </Form.Control.Feedback>
                            </div>
                            <button className="btn" style={{ paddingLeft: "55px" }} type="button" onClick={() => remove(l)}>
                                <MdDelete />
                            </button>
                        </Form.Group>
                    </div>
                );
            })}
            <div>
                <Form.Group className={`${st.formField} ${st.new_formFields} d-flex`}>
                    <div className={`${st.tableAction} mb-0`}>
                        <button
                            style={{ color: "#fff", background: "#7f8699" }}
                            type="button"
                            className={`btn`}
                            onClick={() =>
                                append({
                                    key: "",
                                    value: ''
                                })
                            }
                        >
                            Add key
                        </button>

                    </div>
                </Form.Group>
            </div>
        </div>
    );
};
